import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CountStatusComponent } from "./count-status.component";
import { TranslateModule } from "@ngx-translate/core";
import { BarChartRendererModule } from '../table/renderers/bar-chart-renderer/bar-chart-renderer.module';
import { TableModule } from '@valg-shared/components/table/table.module';
import { BarChartModule } from '../bar-chart/bar-chart.module';
import { ResultSummaryModule } from '../result-summary/result-summary.module';
import { SimpleResultSummaryModule } from '../simple-result-summary/simple-result-summary.module';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        BarChartRendererModule,
        TableModule,
        BarChartModule,
        ResultSummaryModule,
        SimpleResultSummaryModule
    ],
  declarations: [
    CountStatusComponent
  ],
  exports: [
    CountStatusComponent
  ]
})
export class CountStatusModule {}
